<template>
  <div v-loading="loading">
    <HomeBannerTop></HomeBannerTop>
    <div class="actor-detail-main">
      <div class="actor-card">
        <div class="tr pointer" @click="goBank">{{ $t('返回') }}</div>
        <div class="actor-card-bottom-box">
          <div class="actor-card-booth">
            <span style="margin-right: 10px;">{{ $t('展位号') }}</span>
            <span class="booth">{{ detail.exhibitionBoothNumber}}</span>
          </div>
        </div>
        <div class="actor-card-bottom-box">
          {{ (detailsInfo.name && detailsInfo.name.content) || detail.name }}
        </div>
        <div class="actor-card-profile flex flex-align-bottom">
          <div class="actor-card-main">
            <div v-for="(item, index) in detailsInfo" :key="index">
              <div class="company-info" v-if="item.content">
                <div v-if="['exhibitionFloor', 'webUrl', 'address', 'linkEmail'].includes(item.keyword)">
                  <div>
                    <span class="actor-card-title">{{ item.title }}: </span>
                    <template v-if="item['title'] == 'webUrl' || item['title'] == 'url3d'">
                      <span v-if="item['title'] == 'webUrl' && item['content']">
                        <a :href="item['content']" target="view_window">{{ item.content }}
                        </a>
                      </span>
                      <span v-else-if="item['title'] == 'url3d'">
                        <a :href="item['content']" target="view_window"> {{ item.content }}
                        </a>
                      </span>
                    </template>
                    <template v-else>
                      {{ item.content }}
                    </template>
                  </div>
                </div>
                <template v-else-if="['enItemIntroduction'].includes(item.keyword) ">
                  <div class="actor-card-title">{{ item.title }}</div>
                  <div class="actor-card-info company-info">
                      <div class="info-content">{{ item.content }}</div>
                  </div>
                </template>
                <template v-else>
                  <div class="actor-card-title">{{ item.title }}</div>
                  <div class="actor-card-info company-info">
                    <template v-if="item['title'] === '是否上市'">
                      {{ item['content'] === true ? $t('Yes') : $t('No') }}
                    </template>
                    <template v-else>
                      <template v-if="item['title'] == 'webUrl' || item['title'] == 'url3d'">
                        <span v-if="item['title'] == 'webUrl' && item['content']">
                          <a :href="item['content']" target="view_window">{{ item.content }}
                          </a>
                        </span>
                        <span v-else-if="item['title'] == 'url3d'">
                          <a :href="item['content']" target="view_window"> {{ item.content }}
                          </a>
                        </span>
                      </template>
                      <template v-else>
                        <div class="info-content">{{ item.content }}</div>
                      </template>
                    </template>
                  </div>
                </template>
              </div>
            </div>



          </div>
          <div class="actor-card-right flex-center">
            <div @click.stop="collect(detail)">
              <template v-if="detail['collected']">
                <img class="iconact_dianzan_full pointer" src="@/assets/card/collect.png" />
              </template>
              <template v-else>
                <img class="iconact_dianzan_full pointer" src="@/assets/card/no_collect.png" />
              </template>
            </div>
            <!-- <img class="m-l-9 m-r-10" style="vertical-align: middle;" src="@/assets/card/thumbs-up.png" /> -->
            <i class="m-l-9 m-r-10 el-icon-view"
              style="vertical-align: middle;font-weight: bold;color: rgba(0,0,0,0.45);"></i>
            <span style="vertical-align: middle;color: rgba(0,0,0,0.45);">{{ detail.pageView || 0 }}</span>
          </div>
        </div>

        <div class="boothMapNavigation pointer" @click="goUrl(detail)">
          <template v-if="language == 'en'">
            <img src="@/assets/home/en/navigation.png" :width="'100%'" />
          </template>
          <template v-else>
            <img src="@/assets/home/cn/navigation.png" :width="'100%'" />
          </template>
        </div>
      </div>
      <div class="exhibit-card" v-if="exhibitList.length > 0">
        <div class="exhibit-card-title">{{ $t('产品图片') }}</div>
        <div class="exhibit-card-box" v-for="(item, index) in exhibitList" :key="index"
          @click="showExhibitDetail(item)">
          <div class="exhibit-card-img">
            <img v-if="item.iconImage" :src="item.iconImage" />
            <img v-else src="@/assets/img/default_image.png" />
          </div>
          <div>
            <div class=" exhibit-card-info-title">{{ item.productName}}
            </div>
            <div class="exhibit-card-info-desc">{{ item.productIntro }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="detailMask" @touchmove.prevent v-if="showDetailMask">

      <div class="detailMaskmain">
        <div class="close">
          <span class="el-icon-circle-close" @click="closeMask"></span>
        </div>
        <div class="maskInfo">
          <div class="productName">{{ maskInfoData.productName }}</div>
          <template v-if="maskInfoData.productIntro">
            <div class="product-title">{{ $t('产品介绍') }}</div>
            <div class="product-desc">{{ maskInfoData.productIntro }}</div>
          </template>
          <template v-if="maskInfoData.iconImageList.length > 0">
            <div class="product-title">{{ $t('产品图集') }}</div>
            <div>
              <img v-for="(item,index) in maskInfoData.iconImageList" :key="index" :src="item" />
            </div>
          </template>
          <template v-else>
            <div class="product-title">{{ $t('产品图集') }}</div>
            <img src="@/assets/img/default_image.png" />
          </template>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <HomeFooter></HomeFooter>

  </div>
</template>

<script>
// 顶部内容
import HomeBannerTop from '../index/HomeBannerTop'
// 底部内容
import HomeFooter from '../index/HomeFooter'
import { mapGetters } from 'vuex'
import { fetchExhibitorDetails, fetchExhibitorProduct } from '@/api/find'
import { eventMixin } from '@/mixins/event.js'
export default {
  name: 'actorDetail',
  mixins: [eventMixin],
  components: {
    HomeBannerTop,
    HomeFooter
  },
  // 添加多语言metaInfo配置
  metaInfo() {
    const isChinese = this.$store.getters.language !== 'en';
    const companyName = (this.detailsInfo.name && this.detailsInfo.name.content) || this.detail.name || '';

    if (isChinese) {
      return {
        title: `${companyName} - 展商详情 - CAC2026中国国际农用化学品及植保展览会`,
        meta: [
          {
            name: 'description',
            content: `${this.detailsInfo.introduction}`
          },
          {
            name: 'keywords',
            content: `${companyName}, 展商详情, CAC2026, 展位号${this.detail.exhibitionBoothNumber || ''}`
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: `https://cacizt-pc.eastfair.com/actorDetail/${this.$route.params.id}`
          }
        ]
      };
    } else {
      return {
        title: `${companyName} - Exhibitor Details - CAC2026 China International Agrochemical & Crop Protection Exhibition`,
        meta: [
          {
            name: 'description',
            content: `${this.detailsInfo.enIntroduction}`
          },
          {
            name: 'keywords',
            content: `${companyName}, Exhibitor Details, CAC2026, Booth ${this.detail.exhibitionBoothNumber || ''}`
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: `https://cacizt-pc.eastfair.com/actorDetail/${this.$route.params.id}`
          }
        ]
      };
    }
  },
  data() {
    return {
      loading: false, // 页面loading
      productLoading:false, // 展品loading
      detail: {}, // 展商详情
      detailsInfo: {}, // 展商显示内容
      exhibitList: [], // 展品列表
      showDetailMask: false, // 遮罩层
      maskInfoData:{} // 遮罩层中数据
    }
  },
  computed: {
    ...mapGetters(['exhibitorId', 'language', 'subjectType', 'info', 'isLogin']),
  },
  mounted() {
    sessionStorage.removeItem('actorID')
    this.fetchDetail()
  },
  methods: {
    //收藏
    collect(data) {
      this.collectEvent({
        id: data.collectionId,
        deleted: data.collected,
        collectionSubjectType: 'ACTOR',
        collectionSubjectId: data.id
      },
        status => {
          this.detail.collected = status
      })
    },
    // 打开遮罩层
    showExhibitDetail(item) {
      this.maskInfoData = item;
      this.showDetailMask = true
    },
    // 关闭遮罩层
    closeMask() {
      this.maskInfoData = {};
      this.showDetailMask = false
    },
    // 获取详情
    fetchDetail() {
     this.loading = true
      fetchExhibitorDetails({
        id: this.$route.params.id,
        showType: 'ACTOR_DETAILS'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            if (res.data.details) {
              res.data.details.forEach(item => {
                if (item.keyword === 'enItemIntroduction') {
                  this.detailsInfo[item.keyword] = {
                    title: item.showValue.title,
                    content: item.showValue.content ? item.showValue.content.split(',').join(', ') : '',
                    keyword: item.keyword
                  }
                 }
                else {
                  this.detailsInfo[item.keyword] = {
                    title: item.showValue.title,
                    content: item.showValue.content,
                    keyword: item.keyword
                  }
                }
                
              })
            }
            this.detail = res.data

            this.fetchProductList()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 展商下产品中心
    fetchProductList() {
      this.productLoading = true
      fetchExhibitorProduct({
        exhibitorId: this.$route.params.id,
        showType: 'PRODUCT_LIST',
        verifyState: 'ONLINE',
        searchKeywords: '',
        questionList: [],
        pageNum: 1,
        pageRows: 1000
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            let list = res.data.list || []
            if (list.length > 0) {
              list.forEach((element) => {
                element.iconImage = element.iconUrl ? element.iconUrl.split(',')[0] : element.iconUrl
                element.iconImageList = element.iconUrl ? element.iconUrl.split(',') : []
              })
            }
            this.exhibitList = list
          }
        })
        .finally(() => {
          this.productLoading = false
        })
    },
    // 返回
    goBank() {
      this.$router.go(-1)
    },
    // 跳转第三方页面
    goUrl(data) {
      // if (data?.url3d) {
      //   window.open(data.url3d, '_blank')
      // }
      // 中英文跳转不同链接
      // if (this.language == 'en') {
      //   window.open(`https://szdt.3dqiye.com/boothplan?exhibitionId=08dd467e763b4db08aa1b40396d06e96&lang=en&boothNum=${data.exhibitionBoothNumber}`, '_blank')
      // } else {
      //   window.open(`https://szdt.3dqiye.com/boothplan?exhibitionId=08dd467e763b4db08aa1b40396d06e96&boothNum=${data.exhibitionBoothNumber}`, '_blank')
      // }
      // TODO 暂时跳转 敬请期待
      window.open(`https://www.3dqiye.com/anli/klyf/cac/qd.html`, '_blank')
    }
  }
    
}
</script>

<style lang="scss" scoped>
.actor-detail-main{
  width: 100%;
  background: #F9F9F9;
}

.info-content {
  max-width: 1040px;
  word-break: break-word;
}

.actor-card, .exhibit-card {
  max-width:1080px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  position: relative;
}

.actor-card-bottom-box {
  border-bottom: 1px solid #038720;
  line-height: 40px;
}

.actor-card-booth {
  display: inline-block;
  padding: 0 16px;
  background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
  color: #fff;
  min-height: 40px;
  line-height: 40px;

  span {
    font-size: 14px;
    vertical-align: middle;
  }

  .booth {
    font-size: 22px;
  }
}

.actor-card-main {
  margin: 24px 0 0 0;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  // max-width: 850px;
  // padding-right: 30px;
}
.actor-card-title{
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 11px;
}
.actor-card-info{
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 24px;
  word-wrap: break-word;

}
.company-info{
  margin-bottom: 28px;
}
.exhibit-card-title{
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  line-height: 18px;
  background: -webkit-linear-gradient(top, #00875E, #0068A9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
.exhibit-card-box{
  display: flex;
  justify-content: flex-start;
  margin: 20px 0;
  cursor: pointer;
}
.exhibit-card-img{
  width:100px;
  height: 100px;
  flex: 0 0 100px;
  margin-right: 20px;
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.exhibit-card-info-title{
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 16px;
  margin: 12px 0;
}
.exhibit-card-info-desc{
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 24px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.boothMapNavigation {
  width: 80px;
  height: 80px;
  position: absolute;
  right: -10%;
  bottom: 5%
}
.actor-card-right{
  margin: 10px 0;
  // text-align: right;
  position: absolute;
  bottom: 10px;
  right: 20px;
}
.detailMask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  overflow: hidden;
}
.close{
  position: relative;
  top: -40px;
  right: -97%;
  color: rgba(255, 255, 255, 0.45);
  font-size: 23px;
  cursor: pointer;
}
.detailMaskmain{
  width: 50%;
  height: 550px;
  background: #fff;
  margin: 10% auto;
  border-radius: 8px;
}
.maskInfo{
  height: 460px;
  padding: 0 24px 24px;
  overflow-y: scroll;
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
    margin-bottom: 20px;
  }
}
.actor-card-profile{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.iconfont {
  margin: 9px 8px;
}

.iconact_dianzan_full {
  border-right: 1px solid #038720;
  padding-right: 10px;
}

.iconxianshimima {
  margin-left: 0;
}
.productName{
  font-weight: 500;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 16px;
}
.product-title{
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 12px;
}
.product-desc {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 26px;
  margin-bottom: 16px;
}

@media (min-width: 320px) and (max-width: 750px) {
  .boothMapNavigation {
    width: 60px;
    height: 60px;
    position: fixed;
    right: 3%;
    bottom: 3%;
    z-index: 100;
  }
    .close {
      position: relative;
      top: -40px;
      right: -93%;
      color: rgba(255, 255, 255, 0.45);
      font-size: 23px;
      cursor: pointer;
    }
    .detailMaskmain {
      width: 90%;
      height: 80%;
      background: #fff;
      margin: 15% auto;
      margin-top: 25%;
      border-radius: 8px;
    }
    .maskInfo {
      height: 90%;
      overflow-y: scroll;
    }
    .actor-card-main{
      padding-right: 0px;
    }
    .actor-card-profile {
      display: block;
    }
   
}
</style>